import { defineMessages } from "react-intl";

export default defineMessages({
  notary: {
    id: "1d885e0d-3aed-46d1-aa60-6d69d3489fcf",
    defaultMessage: "notary",
  },
  notaryPublic: {
    id: "366d4f65-9b10-4a99-870e-4acde3f0225f",
    defaultMessage: "notary",
  },
  verificationMethod: {
    id: "71e81358-002a-4ad5-984d-f78e00508eeb",
    defaultMessage: "ID Validation",
  },

  // Transaction Details Modal
  signingType: {
    id: "7848cdad-63ae-4f1f-ac54-e160f58fc666",
    defaultMessage: "Agent Act",
  },
  transactionDetails: {
    id: "05244808-f2f9-4367-831a-181b1612148c",
    defaultMessage: "Transaction Details",
  },

  // Notary Portal
  signingDocument: {
    id: "04d05467-3785-44b2-beac-1a6b8cb6db05",
    defaultMessage: "Signing Document",
  },

  // Business Portal
  documentCompleteHistoryMessage: {
    id: "8e9ef921-142f-4248-a5ac-18a470dad4c5",
    defaultMessage: "Identity Confirmation Complete",
  },
  businessSetupUploadMessage: {
    id: "d1b6eb5b-ecb6-414b-87f8-d30cdaa4119c",
    defaultMessage: "{upload} the document you need to have signed",
  },
  businessSetupReceiveMessage: {
    id: "ef600699-953b-48b5-b41f-75f26a39822c",
    defaultMessage: "{receive} your signed documents automatically",
  },

  // Signer Portal
  signerDetailsTipWellContent: {
    id: "e73f2d0a-c753-4dbf-97ff-6bbda5c2cdca",
    defaultMessage:
      "Some personal information is required in order to verify your identity. We only use this information to perform a legally compliant identity confirmation, and never share or sell it.",
  },
  signatureNoteTitle: {
    id: "076dbe6e-4fbd-4463-85e1-526db26e8ed4",
    defaultMessage: "Signatures are applied during the video call",
  },
  signatureNoteText: {
    id: "49c28960-7a78-4bdf-883b-2568efaa0b27",
    defaultMessage: "You will be connected after you verify your identity.",
  },
  annotatableTitle: {
    id: "743a203e-3c51-432f-a78f-1f7a6cde2364",
    defaultMessage: "Prepare Document Forms Before Video Meeting",
  },
  nonannotatableTitle: {
    id: "60e1f908-3827-4293-b840-4564393005f1",
    defaultMessage: "Review Document Forms Before Video Meeting",
  },
  completeReview: {
    id: "6089ec95-aa02-48af-9c64-bd80bafed742",
    defaultMessage: "Complete Review",
  },
  continuePrepare: {
    id: "fb59ab60-3443-468f-972d-589f60fc2658",
    defaultMessage: "Continue",
  },
  disclaimerText: {
    id: "faa30f11-7b18-47d0-9709-402d1421d07d",
    defaultMessage:
      "Signatures will be applied during the live video call. You will be connected in the last step.",
  },
  techCheckExplainer: {
    id: "e745eb46-3218-4489-8981-381efb427b84",
    defaultMessage:
      "A built-in camera or connected webcam, microphone, speakers or headphones, and a quality internet connection are required to ensure a successful video call with a notary.",
  },
  techCheckExplainerV2: {
    id: "81e7e135-a76f-4b7f-b76f-dcf53a8a52af",
    defaultMessage:
      "A built-in camera or connected webcam, microphone, speakers or headphones, and a quality internet connection are required to ensure a successful video call with a notary.",
  },
  transactionIsComplete: {
    id: "63df013c-2681-4284-8456-4d045fac5ddb",
    defaultMessage: "Your signing is complete!",
  },
  signerEnterPaymentDetails: {
    id: "185ca4b5-d4ee-4863-8252-9ea4b8e1e751",
    defaultMessage:
      "Please enter your payment details to access {totalCount, plural, one {the completed document} other {the completed documents}}.",
  },
  transactionCustomPriceStartsAt: {
    id: "3cfb5b0a-d234-4818-83d3-044e39d28672",
    defaultMessage: "This transaction starts at {initialPrice}.",
  },
  transactionBasePriceStartsAt: {
    id: "4890d746-3d7d-4a6f-9124-31b8abe77ee4",
    defaultMessage:
      "This transaction starts at {initialPrice}. Additional signed documents cost {esignedDocPrice}.",
  },
  checkingConnection: {
    id: "6b82f4c3-1fb7-487c-9e36-d9d71b22bdef",
    defaultMessage:
      "Checking your internet connection to ensure a quality notary video call. This test will take a few seconds.",
  },
  startAVideoCallWithNotary: {
    id: "e95cda8c-2a90-40c1-9d52-2cefa18936ca",
    defaultMessage: "Up next: Join the notary meeting",
  },
  connectingWithNotary: {
    id: "78ef7e94-f606-45a7-b437-2a7f6e663fbf",
    defaultMessage: "Finding the next available trusted referee...",
  },
  transactionPaidForBy: {
    id: "20a40c40-d524-4c39-a4d7-f5b5d85b90d9",
    defaultMessage: "{organizationName} is paying for this transaction.",
  },
  transactionMayBeBilled: {
    id: "27180058-fd0c-409e-b046-39dbf7033bc1",
    defaultMessage:
      "{organizationName} won't be collecting a payment during the session, but you may be billed afterward.",
  },
  signerSessionExpired: {
    id: "5c099f6d-02d0-4562-9cd1-c0ce140bd1d8",
    defaultMessage:
      "You must verify your identity within 2 hours of connecting with an agent. Please re-enter your information to continue.",
  },
  callWillBeRecorded: {
    id: "2593043b-026d-4a4a-848d-af345fd4e61b",
    defaultMessage:
      "Audio and video will be recorded during the meeting as proof of identity confirmation.",
  },
  notarizePlatformMessage: {
    id: "41821e41-37bf-4886-aa0c-4885a707c961",
    defaultMessage:
      "Notarize connects you by video with a notary to perform secure online identity confirmation — no matter where you're located. {learnMore}",
  },
  handleTransactionSentWelcome: {
    id: "c26cf96b-e8c2-4554-a83f-b0fe2dbbb9b3",
    defaultMessage:
      "Welcome to {companyName}! {organizationName} has sent you {totalCount, plural, one{a document} other{documents}} to sign online",
  },
  handleTransactionGenericWelcome: {
    id: "79d40f39-d89c-4707-b222-da0e7ff40f4e",
    defaultMessage:
      "Welcome to {companyName}. Get your identity confirmed by a notary online. Anytime.",
  },
  organizationSentDocumentForSigning: {
    id: "638006e6-ec38-4813-a616-5e485bac0163",
    defaultMessage:
      "{organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to sign online.",
  },
  getDocumentsSignedAnytime: {
    id: "ae8ae60b-1615-476c-87bf-d2a163413f5f",
    defaultMessage: "Get your identity confirmed by a notary online. Anytime.",
  },
  connectWithNotary: {
    id: "49b4831c-66c0-4547-a006-9a2e19f88b59",
    defaultMessage: "{connect} with a notary over live video",
  },
  connectWithNotaryFromDevice: {
    id: "9f9b5bb1-113e-47c1-a3a1-02bd998de793",
    defaultMessage: "Connect with a notary over live video from your computer, tablet, or phone.",
  },
  notariesAlwaysOnline: {
    id: "07c60621-b154-40ae-af12-8c689c0e96fd",
    defaultMessage: "Notaries{break}always online",
  },
  getItSigned: {
    id: "15777717-6cff-41c5-a6f1-ae73fc3a9f30",
    defaultMessage: "Want to continue on mobile instead? Text yourself a link.",
  },
  bitLandingDocumentMessage: {
    id: "99490a42-a621-46f8-907f-a67f93f84440",
    defaultMessage:
      "{organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to sign online",
  },
  bitLandingExperimentDocumentMessage: {
    id: "0426ab24-c1ba-49b9-97a8-b898f2f342ce",
    defaultMessage:
      "Verify your identity in a few steps and we'll instantly connect you with a certified notary over video call",
  },
  bitLandingDocumentMessageFreeService: {
    id: "fe294b64-89f6-4806-b4ee-2d2fced0ee6a",
    defaultMessage: "This service will be free for you.",
  },
  bitLandingGetStartedMessage: {
    id: "6d2e94e8-f5f2-4346-b53d-5a378df8d5bc",
    defaultMessage: "Review And Sign",
  },
  bitLandingWelcomeSubheader: {
    id: "d147c5ce-0953-42a0-af6c-b2337702b2dd",
    defaultMessage: "Legally Sign Your Documents Online in Minutes",
  },
  signerShareWithAnyone: {
    id: "eada647b-b441-44d8-a1d8-6aa4d299483f",
    defaultMessage: "{share} your completed documents with anyone.",
  },
  signatureAnnotationModalMessage: {
    id: "9fbbfe00-b8ae-4785-a83c-407e0bf33910",
    defaultMessage:
      "You will be connected to a notary in the last step, after you verify your identity.",
  },
  ps1583InstructionsHeader: {
    id: "0e5df712-77e1-4536-a9cf-89d9a0330ab3",
    defaultMessage: "Before we connect you with a notary, add IDs",
  },

  // Verify Portal
  verifyRetrievalResultSuccess: {
    id: "963f48b9-e4be-406c-bbd1-496b4aa3b185",
    defaultMessage: "Success! This document was signed!",
  },
});
